import { render, staticRenderFns } from "./ReflectionShow.vue?vue&type=template&id=bed47aa8&scoped=true&"
import script from "./ReflectionShow.vue?vue&type=script&lang=js&"
export * from "./ReflectionShow.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bed47aa8",
  null
  
)

export default component.exports